/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var VirtualAssistantIcon = createIcon("VirtualAssistantIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'url(#virtual-assistant-a) #308ed4';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": "url(#virtual-assistant-a) #308ed4",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "virtual-assistant-a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23AAE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2071C5",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#virtual-assistant-a) #308ed4",
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 8.5 17.5)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "6",
    r: "3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    width: "10",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "5",
    width: "14",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "10",
    width: "10",
    height: "2",
    rx: "1"
  })));
}, {
  "replaceColor": true
});